import {createAction} from 'redux-actions';

export const QC_TOOLS_ARTWORK_SET = 'QC_TOOLS_ARTWORK_SET';
export const QC_TOOLS_ARTWORK_GET = 'QC_TOOLS_ARTWORK_GET';
export const QC_TOOLS_ARTWORK_RESET = 'QC_TOOLS_ARTWORK_RESET';
export const QC_TOOLS_ARTWORK_WAIT = 'QC_TOOLS_ARTWORK_WAIT';
export const QC_TOOLS_ARTWORK_RETRY = 'QC_TOOLS_ARTWORK_RETRY';
export const QC_TOOLS_ARTWORK_DELETE = 'QC_TOOLS_ARTWORK_DELETE';
export const QC_TOOLS_ARTWORK_DELIVERABLE = 'QC_TOOLS_ARTWORK_DELIVERABLE';
export const QC_TOOLS_ARTWORK_UPLOAD = 'QC_TOOLS_ARTWORK_UPLOAD';
export const QC_TOOLS_ARTWORK_REPLACE = 'QC_TOOLS_ARTWORK_REPLACE';

export const setQcToolsArtwork = createAction(QC_TOOLS_ARTWORK_SET);
export const setQcToolsArtworkToWait = createAction(QC_TOOLS_ARTWORK_WAIT);
export const getQcToolsArtworkAction = createAction(QC_TOOLS_ARTWORK_GET);
export const resetQcToolsArtworkAction = createAction(QC_TOOLS_ARTWORK_RESET);
export const retryQcToolsArtworkAction = createAction(QC_TOOLS_ARTWORK_RETRY);
export const deleteQcToolsArtworkAction = createAction(QC_TOOLS_ARTWORK_DELETE);
export const setQcToolsArtworkDeliverableAction = createAction(
    QC_TOOLS_ARTWORK_DELIVERABLE
);
export const setQcToolsArtworkUploadAction = createAction(QC_TOOLS_ARTWORK_UPLOAD);
export const setQcToolsArtworkReplaceAction = createAction(QC_TOOLS_ARTWORK_REPLACE);
